// extracted by mini-css-extract-plugin
module.exports = {"photo":"FeedPhotosItem_photo__qsMfX","visualizacao":"FeedPhotosItem_visualizacao__1-Gmi"};